import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useTranslation } from 'react-i18next';
import FilterBarFormControl, { FilterBarFormControlProps } from './FilterBarFormControl';
import TextField, { FilledTextFieldProps as TextFieldProps } from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';

export interface FilterBarSearchInputProps extends Omit<TextFieldProps, 'variant'> {
  formControlProps?: Omit<FilterBarFormControlProps, 'children'>;
}

const FilterBarSearchInput: React.FC<FilterBarSearchInputProps> = ({
  formControlProps,
  ...rest
}) => {
  const { t } = useTranslation('AppHeader.Search');

  return (
    <FilterBarFormControl {...formControlProps}>
      <TextField
        variant="outlined"
        placeholder={t('Search')}
        inputProps={{
          'aria-label': t('Search Input')
        }}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          )
        }}
        {...rest}
      />
    </FilterBarFormControl>
  );
};

export default FilterBarSearchInput;
